/**
 * FctCard — wrapper de Card de Ant Design con la cabecera estilizada
 * corporativamente (línea verde de acento + título en negro corporativo).
 *
 * Uso:
 *   <FctCard title="Transmisiones del trimestre" extra={<Button>Ver más</Button>}>
 *     <Statistic value={42} suffix="operaciones" />
 *   </FctCard>
 */

import React from 'react';
import { Card, type CardProps } from 'antd';
import { fctColors } from '../../theme/theme';

interface FctCardProps extends CardProps {
  /**
   * Si `accent` es `true` (por defecto), añade la barra verde a la izquierda
   * de la cabecera. Para tarjetas neutras pasar `false`.
   */
  accent?: boolean;
}

export const FctCard: React.FC<FctCardProps> = ({
  accent = true,
  title,
  children,
  style,
  styles,
  ...rest
}) => {
  const accentTitle =
    accent && title ? (
      <span
        style={{
          display: 'inline-block',
          paddingLeft: 10,
          borderLeft: `3px solid ${fctColors.verdeCorporativo}`,
          color: fctColors.negroCorporativo,
          fontWeight: 500,
        }}
      >
        {title}
      </span>
    ) : (
      title
    );

  return (
    <Card
      title={accentTitle}
      style={{
        borderColor: fctColors.grisBorde,
        ...style,
      }}
      styles={{
        header: {
          borderBottom: `1px solid ${fctColors.grisBorde}`,
          background: fctColors.blanco,
          minHeight: 48,
        },
        ...styles,
      }}
      {...rest}
    >
      {children}
    </Card>
  );
};
